/**
 * Focus the search field when the search bar opens on screens < 992px wide.
 *
 * The field is rendered by Algolia autocomplete or the instantsearch searchbox, possibly after page load, so it is
 * looked up when the bar opens.
 */

const searchBar = document.getElementById('searchBar')

searchBar?.addEventListener('shown.bs.collapse', () => {
  searchBar.querySelector('input')?.focus()
})
